export const initWishlistCallback = (widgetSelector) => {
  const swymCallback = (swat) => {
    document.addEventListener('swym:products-loaded', () => {
      swat.initializeActionButtons(widgetSelector);
    });
  };

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swymCallback);
};

export const updateWishlistURL = () => {
  const newURL = window.location.pathname;
  window.history.pushState({}, document.title, newURL);
};

export const initWishlistProductForms = () => {
  const selectors = {
    formTemplate: '#product-form-template',
    container: '#swym-wishlist-render-container',
    grid: '.swym-wishlist-grid',
    item: '.swym-wishlist-grid li',
    removeButton: '.swym-delete-btn',
    productForm: '.product-form',
  };

  const renderWishlist = (swat) => {
    const container = document.querySelector(selectors.container);
    const productGrid = container.querySelector(selectors.grid);

    container.addEventListener('submit', (event) => {
      if (!event.target.matches(selectors.productForm)) return;

      event.preventDefault();

      const formData = new FormData(event.target);
      const item = {
        id: formData.get('id'),
        quantity: formData.get('quantity'),
      };

      const card = event.target.closest(selectors.item);
      const removeButton = card.querySelector(selectors.removeButton);

      event.target.disabled = true;

      window.sideCart.handleAddToCartEvent(item, true, {}, () => {
        event.target.disabled = false;

        // Can't find a way to hook into refreshing the grid
        if (removeButton) {
          removeButton.click();
        }
      });
    });

    // Fetch products from wishlist
    swat.fetch((products) => {
      products.forEach((product, index) => {
        // Get the item from the grid
        const productCard = productGrid.children[index];

        // Create the URL
        const url = new URL(product.du);

        // Add form view to the URL
        url.searchParams.set('view', 'form');

        // Fetch the product form template
        fetch(`${url.pathname}${url.search}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => response.text())
          .then((html) => {
            // Parse the HTML
            const htmlDocument = new DOMParser().parseFromString(html, 'text/html');

            // Get the form
            const form = htmlDocument.querySelector(selectors.formTemplate);

            // If the form is not found, return
            if (!form) return;

            // Insert the form into the product card
            productCard.insertAdjacentHTML('beforeend', form.outerHTML);
          })
          .catch((error) => {
            console.error('Failed to fetch product form:', error);
          });
      });
    });
  };

  const swymRenderWishlistCallback = (swat) => {
    // Check if the container exists on the page
    const container = document.querySelector(selectors.container);
    if (!container) return;

    // Create observer to check if the grid exists
    const observer = new MutationObserver(() => {
      // If the grid exists, disconnect the observer and render the wishlist
      if (container.querySelector(selectors.grid)) {
        observer.disconnect();
        renderWishlist(swat);
      }
    });

    // Observe the container for changes
    observer.observe(container, {
      childList: true,
      subtree: true,
    });
  };

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swymRenderWishlistCallback);
};
